import { useState } from 'react'
import { NAV_MODE } from './navMode.js'

/**
 * Which half of the rail is showing.
 *
 * Opening the Schedules page switches the rail to Pulse — the page and the rail
 * would otherwise disagree about where the user is — but only on the transition,
 * so switching back to Chat while the page is open still holds.
 */
export function useHomeNavMode(automationSurfaceActive) {
  const [mode, setMode] = useState(automationSurfaceActive ? NAV_MODE.PULSE : NAV_MODE.CHAT)
  const [seenActive, setSeenActive] = useState(Boolean(automationSurfaceActive))

  if (Boolean(automationSurfaceActive) !== seenActive) {
    setSeenActive(Boolean(automationSurfaceActive))
    if (automationSurfaceActive) setMode(NAV_MODE.PULSE)
  }

  return { mode, setMode }
}
